import * as React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from './material-ui';
import { ApolloProvider } from './apollo-utils';
import App from './screens';

ReactDOM.render(
	<ApolloProvider>
		<ThemeProvider>
			<App />
		</ThemeProvider>
	</ApolloProvider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js